import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import FoundingMember from "@/components/FoundingMember";

/**
 * Dedicated landing page for the Pula Founding Member subscription.
 * Cross-linked from Fair Connect / Pula so both sister sites share
 * ONE subscription flow and ONE Stripe account.
 */
export default function FoundingMemberPage() {
  return (
    <main data-testid="founding-member-page" className="bg-white">
      {/* Slim breadcrumb */}
      <div className="py-6 border-b mv-hairline">
        <div className="max-w-6xl mx-auto px-4 md:px-8 text-[13px]" style={{ color: "var(--mv-muted)" }}>
          <Link to="/" className="inline-flex items-center gap-1 hover:mv-green-text" data-testid="fm-page-back">
            <ArrowLeft size={13}/> Back to home
          </Link>
        </div>
      </div>

      {/* Hero + full FoundingMember section */}
      <section className="pt-14 md:pt-20 pb-4">
        <div className="max-w-6xl mx-auto px-4 md:px-8 text-center max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.28em] mx-auto" style={{ color: "var(--mv-gold)" }}>§ Support the mission</div>
          <h1 className="mt-4 font-display text-4xl md:text-6xl mv-green-text leading-[1.02] max-w-3xl mx-auto">
            Become a <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Pula Founding Member.</span>
          </h1>
          <p className="mt-5 text-[15.5px] leading-relaxed max-w-2xl mx-auto" style={{ color: "var(--mv-ink)" }}>
            One cup of tea a month. That's all it takes to help us open the doors to fair home ownership across Southern Africa — and to show us we're not doing this alone.
          </p>
        </div>
      </section>

      <FoundingMember />
    </main>
  );
}
